'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var Suggestions_module = require('./Suggestions.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var Suggestions = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, role = _a.role;
    return (jsxRuntime.jsx("ul", tslib.__assign({ className: cx__default.default('list-group', Suggestions_module.default['suggestions'], className), role: role }, { children: children })));
};

exports.Suggestions = Suggestions;
//# sourceMappingURL=Suggestions.js.map
